import React, { useEffect, useState } from 'react'
import {
  AlertError,
  FormDashboardLabel as Label,
  FormRow,
  SaveButton,
  VisibilityRadios as Radios
} from '../../../components'
import { visibilityField } from '../../../features/visibility/config'
import { sentenceTitleCase, visibilityWordBlacklist } from '../../../utils'

const FormVisibility = ({
  fieldKey = 'program',
  defaultValue = {},
  onSave = () => {},
  requesting = false,
  errorMessage,
  setErrorMessage
}) => {
  const [form, setForm] = useState({})

  const handleRadioChanges = (e) => {
    setForm({
      ...form,
      [e.target.name]: parseInt(e.target.value)
    })
  }

  const handleSave = () => {
    if(requesting === false){
      onSave(form)
    }
  }

  useEffect(() => {
    if(defaultValue && Object.keys(defaultValue).length > 0){
      setForm(defaultValue)
    } else if (visibilityField[fieldKey]) {
      setForm(visibilityField[fieldKey])
    }
  }, [defaultValue, fieldKey])

  return (
    <div>
      {
        Object.keys(form).map((key) => (
          <FormRow key={key}>
            <div className="mb-5 lg:mb-10">
              <Label>{sentenceTitleCase(key.split('vsb')[1], visibilityWordBlacklist)}</Label>
              <div className="pt-3">
                <Radios
                  name={key}
                  value={form[key]}
                  onChange={e => {e.persist(); handleRadioChanges(e)}}
                />
              </div>
            </div>
          </FormRow>
        ))
      }

      {
        errorMessage !== null &&
        <div className="mb-8">
          <AlertError message={errorMessage} onClose={() => setErrorMessage(null)}/>
        </div>
      }

      <SaveButton
        onClick={handleSave}
        disabled={requesting}
        isLoading={requesting}
      />
    </div>
  )
}

export { FormVisibility }
